module.exports = __webpack_public_path__ + "img/my-subscription.d29f0ee3.svg";